import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading = () => {
    return (
        <div className='d-flex align-items-center justify-content-center loading-div'>
            <Spinner animation="border" variant="primary" role="status" className="loading d-flex justify-content-center"></Spinner>
        </div>
    )
}

export { Loading }
